<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active" aria-current="page">パスワード再発行</li>
      </ol>
    </nav>
    <div class="container-fluid main-container">
      <div class="d-flex flex-wrap">
        <div class="container">
          <h5 class="mb-3"></h5>
          <div class="modal-dialog modal-md">
            <div class="modal-content">
              <div class="modal-body">
                <form class="needs-validation">
                  <h6 class="font-weight-bold">メールアドレス</h6>
                  <input
                    type="text"
                    v-model="email"
                    class="form-control mb-3"
                    required>
                  <div class="invalid-feedback">
                    メールアドレスは必須です。
                  </div>
                </form>
              </div>
              <div class="modal-footer justify-content-between">
                <div>
                  <a class="btn btn-link decoration-underline" href="login">ログインへ</a>
                </div>
                <button type="button" class="btn btn-primary" v-on:click="beforeReset">パスワード再発行のメール送信</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <vue-element-loading :active="isLoading" :is-full-screen="true"/>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'

export default {
  name: 'UserLoginReset',
  data () {
    return {
      email: '',
      isLoading: false
    }
  },
  components: {
    VueElementLoading
  },
  methods: {
    beforeReset: function () {
      var self = this

      var forms = document.getElementsByClassName('needs-validation')
      Array.prototype.filter.call(forms, function (form) {
        if (form.checkValidity() === true) {
          self.passwordReset()
        }
        form.classList.add('was-validated')
      }, false)
    },
    async passwordReset () {
      var self = this
      try {
        self.isLoading = true

        let params = {
          email: self.email
        }
        let result = await this.$http.post(this.$api_url.account_forgot_password, params)
        if (result.data.status === true) {
          self.$toastr.info('パスワード再発行のメールを送信しました。', '完了')
        } else {
          self.$toastr.error(result.message, 'エラー')
        }
        self.isLoading = false
      } catch (error) {
        self.isLoading = false
        self.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
        console.log('account:forgot_password:catch(error): ', error)
      }
    }
  }
}
</script>
